import { render, staticRenderFns } from "./userInfoTpl.vue?vue&type=template&id=5922af4d&scoped=true&"
import script from "./userInfoTpl.vue?vue&type=script&lang=js&"
export * from "./userInfoTpl.vue?vue&type=script&lang=js&"
import style0 from "./userInfoTpl.vue?vue&type=style&index=0&id=5922af4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5922af4d",
  null
  
)

export default component.exports